import { createI18n } from 'vue-i18n/dist/vue-i18n.esm-bundler.js';
import messages from './lang';

const i18n = createI18n({
  globalInjection: true,
  locale: sessionStorage.getItem('locale')
    ? sessionStorage.getItem('locale').toUpperCase()
    : 'EN',
  legacy: false,

  messages,
});

export default i18n;
